import { InjectionToken } from '@angular/core';

export const SOFTLINE_CONFIG_TICKET = new InjectionToken<TicketConfig>('TICKET_CONFIG');

export interface TicketConfig {
  isCustomer: boolean;
  selectedFilterIndex?: number;
}
